import React from "react";
import { useState } from "react";
import MissionAndVision from "../Components/MissionAndVision";
import HomeBanner from "../Components/Banners/HomeBanner";

import Benifits from "../Components/Benifits";
import ComingSoon from "../Components/ComingSoon";
import Contact from "../Components/Contact";
import Footer from "../Components/Footer";
import Nav from "../Components/Navbar/Nav";
// import News from "../Components/News";
import BenefitsOfJoining from "../Components/BenefitsOfJoining";
import Roadmap from "../Components/Roadmap";
import Team from "../Components/Team";
import RecentEvents from "../Components/Events/RecentEvents";

export default function Home({
  darkToggle,
  setDarkToggle
}) {
  const [buy, setBuy] = useState(false);
  const [comingSoon, setComingSoon] = useState(false);

  const showPopup = () => {
    setComingSoon(!comingSoon);
  };
  return (
    <>
      <Nav
        darkToggle={darkToggle}
        setDarkToggle={setDarkToggle}
        showPopup={showPopup}
        comingSoon={comingSoon}
      />
      {comingSoon && <ComingSoon showPopup={showPopup} />}

      <HomeBanner />

      <RecentEvents />

      <MissionAndVision showPopup={showPopup} />
      
      <BenefitsOfJoining />

      <Roadmap />

      
      <Benifits />

      <Team />

      <Contact />
      <Footer />
    </>
  );
}
